import packageJson from "../../package.json";
import WalletConnectProvider from "../providers/wallet-connector/WalletConnectProvider";
import { ContractProvider, useVersion } from "../providers/ContractProvider";

function About() {
  const version = useVersion();
  return (
    <div>
      <h1>About</h1>
      <h2>App Version: {packageJson.version}</h2>
      <h2>Contract Version: {version}</h2>
    </div>
  );
}

export default function AboutPage() {
  return (
    <WalletConnectProvider>
      <ContractProvider>
        <About />
      </ContractProvider>
    </WalletConnectProvider>
  );
}
